export const ALERT_ERROR_DEFAULT_MESSAGE = 'Ocorreu um erro'